import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';

import { appArrowLink16Icon } from '@icons/arrow-link-16';

@Component({
  selector: 'app-panel-link',
  imports: [SvgIconComponent, NgClass],
  templateUrl: './panel-link.component.html',
  styleUrl: './panel-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelLinkComponent {
  public label = input.required<string>();
  public type = input<'primary' | 'secondary'>('primary');
  public disabled = input<boolean>(false);

  constructor() {
    injectRegisterIcons(appArrowLink16Icon);
  }
}
